// Generated by CoffeeScript 1.9.1
var ImportMenu, MenuBuilder, k;
MenuBuilder = require("../menubuilder");
k = require("koala-js");
module.exports = ImportMenu = MenuBuilder.extend({
  initialize: function initialize(data) {
    this.g = data.g;
    this.el.style.display = "inline-block";
    return this.msa = data.msa;
  },
  render: function render() {
    var msa, uploader;
    msa = this.msa;
    uploader = k.mk("input");
    uploader.type = "file";
    uploader.style.display = "none";
    uploader.multiple = true;
    uploader.addEventListener("change", function () {
      var files;
      files = uploader.files || [];
      return msa.u.file.importFiles(files);
    });
    this.el.appendChild(uploader);
    this.setName("Import");
    this.addNode("URL", function (_this) {
      return function (e) {
        var url;
        url = prompt("URL", "http://rostlab.org/~goldberg/clustalw2-I20140818-215249-0556-53699878-pg.clustalw");
        return _this.msa.u.file.importURL(url, function () {});
      };
    }(this));
    this.addNode("From file", function (_this) {
      return function () {
        return uploader.click();
      };
    }(this));
    this.addNode("Drag & Drop", function (_this) {
      return function () {
        return alert("Yep. Just drag & drop your file");
      };
    }(this));
    this.el.appendChild(this.buildDOM());
    return this;
  }
});